import { Component, OnInit, Input, EventEmitter, Output, ViewChild, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../common/services/common.service';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { ProfileConstants } from '../../../../app/core/routing/services/profile_api/constants/profile.constant';
import { Profile } from '../../../modules/profile/interface/profile.i';

@Component({
  selector: 'iposcen-duplicate',
  templateUrl: './duplicate.component.html',
  styleUrls: ['./duplicate.component.scss']
})
export class DuplicateComponent implements OnInit {
  @Input() profileName: string;
  @Input() profileData: Profile[] = [];
  @Output() readonly duplicate = new EventEmitter<string>();
  duplicateHead: string;
  cancel: string;
  duplicateProfileBtn: string;
  profName: string;
  profileNameValidationMsg: string;
  newProfileName: string;
  isDisableBtn: boolean;
  isDuplicateProfileNameValid: boolean;
  direction: string;
  specialChar = false;
  @ViewChild('duplicateProfile') private modalContent: TemplateRef<DuplicateComponent>;

  private modalRef: NgbModalRef;
  private modalOption: NgbModalOptions = {};
  constructor(private modalService: NgbModal,
    private cmnService: CommonService) { }

  ngOnInit(): void {
    this.direction = this.cmnService.direction;
    this.newProfileName = '';
    this.isDisableBtn = true;
    this.profileNameValidationMsg = ProfileConstants.PROFILE_NAME_ALREADY_EXISTS;
    this.duplicateHead = GlobalConstants.DUPLICATE;
    this.cancel = GlobalConstants.CANCEL;
    this.duplicateProfileBtn = GlobalConstants.DUPLICATE_PROFILE;
    this.profName = GlobalConstants.PROFILE_NAME;
    this.isDuplicateProfileNameValid = false;
  }

  open() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(this.modalContent, this.modalOption);
    this.modalRef.result.then();
    this.newProfileName = '';
    this.isDuplicateProfileNameValid = false;
    this.specialChar = false;
  }

  close(): void {
    this.modalRef.dismiss();
    this.specialChar = false;
  }

  createDuplicateProfile(newProfileName: string) {
    this.isDuplicateProfileNameValid = false;
    this.profileData.forEach(ele => {
      if (!this.isDuplicateProfileNameValid) {
        this.isDuplicateProfileNameValid = (ele.profileName.toUpperCase() === newProfileName.toUpperCase()) ? true : false;
      }
    });
    if (!this.isDuplicateProfileNameValid) {
      this.duplicate.emit(newProfileName.trim());
      this.modalRef.dismiss();
    }
  }

  checkDuplicateName(inputValue) {
    this.isDisableBtn = inputValue.length === 0;
  }

  checkDuplicateProfileName(event) {
    this.specialChar = false;
    if (GlobalConstants.PROFILE_NAME_FORMAT.test(event.target.value)) {
      event.target.value = event.target.value.replace(GlobalConstants.PROFILE_NAME_FORMAT, '').trim();
      this.specialChar = true;
      this.newProfileName = event.target.value;
    }
  }
}
